import React from "react"

import { BrowserInfo } from "detect-browser"

import {
  ArrowTopRightOnSquareIcon,
  CheckIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/solid"

export type JoinAsGhostProps = {
  validBrowser?: boolean
  browserMessage?: string
  browser?: BrowserInfo
}

const JoinAsGhost: React.FC<JoinAsGhostProps> = ({
  validBrowser,
  browserMessage,
  browser,
}) => {
  const recommendedBrowser = browser?.os === "iOS" ? "Safari" : "Google Chrome"
  return (
    <div>
      <p>
        You are joining this cloudroom as a ghost. You will be able to see and
        hear the participants, but they will not be able to see or hear you.
      </p>

      <div>
        <span>Browser: </span>
        {validBrowser ? (
          <span className="text-green-600">
            Compatible{" "}
            <CheckIcon className="ml-1 inline h-5 w-5 align-middle" />
          </span>
        ) : (
          <>
            <span className="text-red-500">
              {browserMessage}{" "}
              <ExclamationTriangleIcon className="mr-2 inline-block h-5 w-5 align-middle lg:mr-4" />
            </span>
            <ol className="pl-5 [&>li]:list-decimal">
              <li>
                Make sure {recommendedBrowser} is installed on your device. If
                it is not, you can download it{" "}
                {recommendedBrowser === "Safari" ? (
                  "in the app store."
                ) : (
                  <a
                    href="https://www.google.com/chrome/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex cursor-pointer items-center text-sky-600 hover:underline"
                  >
                    <span>here.</span>
                    <ArrowTopRightOnSquareIcon className="ml-1 inline h-4 w-4" />
                  </a>
                )}
              </li>
              <li>Copy the current url.</li>
              <li>
                Open {recommendedBrowser} and paste the url into the search bar.
                Make sure you have your Air Tutors login credentials ready in
                case you need to log in again.
              </li>
            </ol>
          </>
        )}
      </div>
    </div>
  )
}

export default JoinAsGhost
